<template>
  <SelectionList
    v-model="value"
    :options="options"
    :multi="false"
    clickable-option="custom-control"
    density="8"
    v-slot="{ label, disabled, isSelected, isFocussed, toggleSelection, index }"
  >
    <SelectableCard
      boxed
      @click.stop="disabled ? null : toggleSelection($event, label.value, index)"
      @keyup.enter="disabled ? null : toggleSelection($event, label.value, index)"
      :selected="isSelected"
      :focussed="isFocussed"
      :disabled="disabled"
    >
      <template #title>
        {{ label.title || label }}
      </template>

      <template #text> {{ label.text }} </template>

      <template #input>
        <RadioButton :modelValue="true" :model="isSelected" :disabled="disabled" />
      </template>
    </SelectableCard>
  </SelectionList>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { ListOptions } from './SelectionList.vue';

/**
 * A single-select SelectionList wrapper with SelectableCard as the custom control component
 */
export default defineComponent({
  name: 'SelectableCardList',
  emits: { 'update:modelValue': null },

  props: {
    modelValue: {
      type: String,
      required: true,
    },

    options: {
      type: Array as PropType<ListOptions>,
      required: true,
    },
  },

  computed: {
    value: {
      get(): string {
        return this.modelValue;
      },
      set(value: string) {
        this.$emit('update:modelValue', value);
      },
    },
  },
});
</script>
